import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/firebase";
import { useEffect, useState } from "react";

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const [role, setRole] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkRole = async () => {
      if (!user) {
        setChecking(false);
        return;
      }

      const snap = await getDoc(doc(db, "users", user.uid));
      setRole(snap.data()?.role || "founder");
      setChecking(false);
    };

    checkRole();
  }, [user]);

  if (loading || checking) return null;

  if (!user) return <Navigate to="/login" />;

  if (adminOnly && role !== "admin") {
    return <Navigate to="/dashboard" />;
  }

  return children;
}

export default ProtectedRoute;
